export default __webpack_public_path__ + "static/pragicts-software-development-process-5b9ecaca728deb277f71d0987552832c.png";